import React from "react";
import { ImageProvider } from "../../../utils/image-provider";
import NewBannerHeading from "../heading/NewBannerHeading";
import AiSummaryWidget from "../../ai-summary/AiSummaryWidget";

const NewCommonBanner = ({ data, renderAiSummary = true }) => {
  const { desktop_bg, heading, mobile_bg } = data || {};
  return (
    <>
      <div className="banner-section">
        <div className="relative lg:h-[29.45vw] h-[80vw]">
          <div className="img-overlay absolute top-0 left-0 w-full h-full bg-[#030A0C99] z-10"></div>
          <div className="xl:block hidden h-full">
            <ImageProvider
              Image={desktop_bg}
              alt={desktop_bg?.alternativeText || "banner-image"}
              tailwindStyle={"w-full object-cover h-full !static"}
            />
          </div>
          <div className="xl:hidden block h-full">
            <ImageProvider
              Image={mobile_bg}
              alt={mobile_bg?.alternativeText || "banner-image"}
              tailwindStyle={"object-cover h-full !static"}
            />
          </div>
          <div className="absolute z-20  md:w-[90%] container top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] text-white text-center">
            <div className="md:w-[90%] w-[100%] text-center mx-auto relative">
              <div className="flex justify-center">
                <NewBannerHeading text={heading} textColor={"#FFFFFF"} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {renderAiSummary ? <AiSummaryWidget /> : null}
    </>
  );
};

export default NewCommonBanner;
